import { render, staticRenderFns } from "./RoleSuccessCreate.vue?vue&type=template&id=092048a8&scoped=true"
import script from "./RoleSuccessCreate.vue?vue&type=script&lang=js"
export * from "./RoleSuccessCreate.vue?vue&type=script&lang=js"
import style0 from "./RoleSuccessCreate.vue?vue&type=style&index=0&id=092048a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092048a8",
  null
  
)

export default component.exports